export const REPORT_RECEIVED = 'REPORT_RECEIVED'
export const REPORT_UNLOADED = 'REPORT_UNLOADED'